<ts-dialog [title]="'Select the layout'" (closeDialog)="matDialogRef.close()">
  <form [formGroup]="form" ts-dialog-body>
    <ts-select
      [items]="templates$ | async"
      itemKey="id"
      itemLabel="name"
      class="w-full"
      formControlName="template_id"
      [uiOptions]="{
        roundedBorders: false,
        placeholder: 'Layout',
        searchPlaceholder: 'Search for a Layout...',
        size: 'small',
      }"
    />
  </form>
  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" (click)="matDialogRef.close()">Cancel</ts-button>
    <ts-button variant="primary" (click)="save()">Save</ts-button>
  </div>
</ts-dialog>
